import { CourseView } from "components/materials/section/content/SectionView";

export default function Page() {
  return <CourseView />;
}
